import anime from 'animejs';
import { EASE_OUT } from 'helpers/easings';
import { bindMethod } from 'helpers/bind';
import store from 'store';
import mqStore from 'store/mqStore';
import MenuPanel from './MenuPanel';
import { durations } from './motion';
const getFirstPanelItemClass = (item, category) => {
    if (category !== null) {
        item.classList.add('inactive');
        if (item.dataset.category === category) {
            item.classList.remove('inactive');
            item.classList.add('active');
        }
        else {
            item.classList.remove('active');
        }
    }
    else {
        item.classList.remove('inactive', 'active');
    }
};
export default class MenuFirstPanel extends MenuPanel {
    _opened = false;
    get opened() {
        return this._opened;
    }
    set opened(value) {
        this._opened = value;
        this.el.classList.toggle('visible', value);
    }
    bindEvents(add) {
        const method = bindMethod(add);
        super.bindEvents(add);
        this.refs.items.forEach((item) => {
            if (item.tagName !== 'A')
                item[method]('click', (e) => this.onItemClick(e));
            else
                item[method]('click', this.onLinkClick);
            item[method]('mouseenter', (e) => this.onItemOver(e));
            // item[method]('mouseleave', (e) => this.onItemOut())
        });
        this.refs.secondaryLinks?.forEach((item) => {
            item[method]('mouseover', (e) => this.onSecondaryLinksOver(e));
            item[method]('mouseleave', this.onSecondaryLinksOut);
        });
        this.refs.toggleStoreLocator?.forEach(toggle => toggle[method]('click', () => this.onToggleStoreSelector()));
    }
    onToggleStoreSelector = () => {
        store.drawer.set('webstore-switcher');
    };
    onLinkClick = () => {
        store.drawer.set(null);
    };
    onItemOver(event) {
        const item = event.currentTarget;
        if (!mqStore.narrowDesktop.get()) {
            if (item.tagName === 'A') {
                store.drawer.set(null);
            }
            else {
                store.drawer.set('menu');
                this.emit('category:change', item.dataset.category);
            }
        }
        this.refs.items.forEach((item) => {
            item.classList.remove('active');
            item.classList.add('inactive');
        });
        item.classList.remove('inactive');
        item.classList.add('active');
    }
    onItemClick = (e) => {
        const button = e.currentTarget;
        const category = button.dataset.category;
        if (this.category === category)
            return;
        this.category = category;
        this.onItemOut();
        this.emit('category:change', category);
    };
    onItemOut() {
        this.refs.items.forEach((item) => {
            getFirstPanelItemClass(item, this.category);
        });
    }
    onSecondaryLinksOver = (event) => {
        this.refs.secondaryLinks.forEach((item) => {
            item.classList.remove('active');
            item.classList.add('inactive');
        });
        const item = event.currentTarget;
        item.classList.remove('inactive');
        item.classList.add('active');
    };
    onSecondaryLinksOut = () => {
        this.refs.secondaryLinks.forEach((item) => {
            item.classList.remove('inactive');
            item.classList.remove('active');
        });
    };
    open(quiet = false) {
        if (!mqStore.narrowDesktop.get())
            return;
        let m, m1;
        const timeout = {
            time: 0
        };
        m = anime({
            targets: this.el,
            translateX: {
                value: ['-50%', 0],
                easing: EASE_OUT,
                duration: durations.FIRST_PANEL_TRANSLATE_IN
            },
            opacity: {
                value: [0, 1],
                easing: 'linear',
                duration: durations.FIRST_PANEL_OPACITY_IN
            },
            complete: () => {
                this.opened = true;
            }
        });
        m1 = anime({
            targets: timeout,
            time: 1,
            duration: durations.FIRST_PANEL_TRANSLATE_IN / 2,
            begin: () => {
                if (!quiet)
                    this.emit('open:begin');
            },
            complete: () => {
                if (!quiet)
                    this.emit('open:complete');
            }
        });
        this.motions.push(m, m1);
        if (!quiet)
            this.enter();
        else
            this.leave(quiet);
    }
    async close() {
        if (!mqStore.narrowDesktop.get())
            return;
        /** D: Panel lists -> staggered entrance on list and list children */
        this.refs.lists?.forEach((list, index) => {
            const mList = anime({
                targets: list.children,
                opacity: {
                    value: [1, 0],
                    duration: durations.FIRST_PANEL_OPACITY_OUT / 2,
                    easing: 'linear'
                }
            });
            this.motions.push(mList);
        });
        const m = anime({
            targets: this.el,
            translateX: {
                value: '-50%',
                easing: 'easeInSine',
                duration: durations.FIRST_PANEL_TRANSLATE_OUT
            },
            opacity: {
                value: 0,
                easing: 'linear',
                duration: durations.FIRST_PANEL_OPACITY_OUT
            },
            complete: () => {
                this.opened = false;
                this.reset();
            }
        });
        this.motions.push(m);
    }
    enter() {
        if (!mqStore.narrowDesktop.get())
            return;
        /** D: Panel lists -> staggered entrance on list and list children */
        this.refs.lists?.forEach((list, index) => {
            const mList = anime({
                targets: list.children,
                translateX: {
                    value: [-50, 0],
                    delay: anime.stagger(durations.FIRST_PANEL_ITEMS_STAGGER, { start: durations.FIRST_PANEL_ITEMS_TRANSLATE_IN_DELAY + index * durations.FIRST_PANEL_LIST_STAGGER_IN }),
                    duration: durations.FIRST_PANEL_TRANSLATE_IN,
                    easing: EASE_OUT
                },
                opacity: {
                    value: [0, 1],
                    delay: anime.stagger(durations.FIRST_PANEL_ITEMS_STAGGER, { start: durations.FIRST_PANEL_ITEMS_OPACITY_IN_DELAY + index * durations.FIRST_PANEL_LIST_STAGGER_IN }),
                    duration: durations.FIRST_PANEL_OPACITY_IN,
                    easing: 'linear'
                }
            });
            this.motions.push(mList);
        });
    }
    leave(force = false) {
        if (!mqStore.narrowDesktop.get())
            return;
        this.refs.lists?.forEach((list, index) => {
            if (force) {
                anime.set(list.children, {
                    translateX: -50,
                    opacity: 0
                });
            }
            else {
                const mList = anime({
                    targets: list.children,
                    translateX: {
                        value: [0, -50],
                        delay: anime.stagger(durations.FIRST_PANEL_ITEMS_STAGGER, { start: index * durations.FIRST_PANEL_LIST_STAGGER_IN }),
                        duration: durations.FIRST_PANEL_TRANSLATE_IN,
                        easing: EASE_OUT
                    },
                    opacity: {
                        value: [1, 0],
                        delay: anime.stagger(durations.FIRST_PANEL_ITEMS_STAGGER, { start: index * durations.FIRST_PANEL_LIST_STAGGER_IN }),
                        duration: durations.FIRST_PANEL_OPACITY_IN,
                        easing: 'linear'
                    }
                });
                this.motions.push(mList);
            }
        });
    }
    forceOpen() {
        anime.set(this.el, { translateX: 0, opacity: 1 });
        this.refs.lists?.forEach((list) => {
            anime.set(list.children, { translateX: 0, opacity: 1 });
        });
    }
    forceClose() {
        anime.set(this.el, { translateX: '-50%', opacity: 0 });
        this.refs.lists?.forEach((list) => {
            anime.set(list.children, { translateX: -50, opacity: 0 });
        });
    }
    reset() {
        super.reset();
        this.onItemOut();
        this.el.style.opacity = '';
        this.el.style.transform = '';
        this.el.style.clipPath = '';
        this.opened = false;
        this.category = null;
        this.refs.lists?.forEach((list) => {
            list.style.opacity = '';
            list.style.transform = '';
        });
    }
}
